import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30" fill="none" {...props}>
    <path fill="#B2B2B2" d="M11.25 0H5.625v3.75h-3.75v5.625h26.25V3.75h-3.75V0H18.75v3.75h-7.5zM28.125 13.125H1.875v15h26.25z" />
  </svg>
);
export default SvgCalendar;
